import customClientAxios from "./customClientAxios";
import { isNullOrUndefined } from "./utils";
export const callNonStoreApi = (endpoint, payload, headers) => {
  if (isNullOrUndefined(payload)) {
    return customClientAxios().get(endpoint, headers);
  }
  return customClientAxios().post(endpoint, payload, headers);
};


export const callNonStoreApiNew = (method, endpoint, payload, headers) => {
  const axiosInstance = customClientAxios();

  switch (method.toLowerCase()) {
    case "get":
      return axiosInstance.get(endpoint, { headers });
    case "post":
      return axiosInstance.post(endpoint, payload, { headers });
    case "put":
      return axiosInstance.put(endpoint, payload, { headers });
    case "delete":
      return axiosInstance.delete(endpoint, { headers });
    default:
      throw new Error(`Unsupported HTTP method: ${method}`);
  }
};
